export default {
  PanelTitle: 'Does #{caregiverName} feel like a match?',
  PanelSubtitle: 'Your feedback helps us find the perfect caregiver',
  DrawerTitle: {
    IsAMatch: 'What makes #{caregiverName} a match?',
    IsNotAMatch: 'What about #{caregiverName} didn\'t match your needs?',
  },
  DrawerSubtitle: {
    IsAMatch: 'This helps us find more great matches for you',
    IsNotAMatch: 'This is completely normal and helps us refine your recommendations',
  },
  IsAMatchButton: 'I want to meet #{caregiverName}',
  IsNotAMatchButton: 'Not a match',
  FeedbackOptionsTitle: 'Select all that apply:',
  FeedbackOptions: {
    SkillsAndServices: '#{caregiverName}\'s Skills & Services',
    Experience: '#{caregiverName}\'s Experience',
    Language: '#{caregiverName}\'s Languages',
    Location: '#{caregiverName}\'s Location',
    Credentials: '#{caregiverName}\'s Credentials',
    Personality: '#{caregiverName}\'s Personality',
    Other: 'Something else',
  },
  AdditionalCommentsTitle: 'Anything else? (Optional)',
  AdditionalCommentsPlaceholder: 'Please share any additional thoughts...',
  Cancel: 'Cancel',
  Submit: {
    IsAMatch: 'Request Meet & Greet',
    IsNotAMatch: 'Submit Feedback',
  },
  SubmissionAlert: {
    IsAMatch: 'Thanks! Your CareQuilt team will be in touch.',
    IsNotAMatch: 'Thanks for sharing. We\'ll refine your matches going forward.',
  },
};
